import { useState, useEffect } from "react";
import { Building2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface BusinessCardPhotoProps {
  businessId: string;
  businessName: string;
}

export function BusinessCardPhoto({ businessId, businessName }: BusinessCardPhotoProps) {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    async function fetchPhoto() {
      const { data } = await supabase
        .from("business_photos")
        .select("photo_url")
        .eq("business_id", businessId)
        .order("display_order", { ascending: true })
        .limit(1);

      if (data && data.length > 0) {
        setPhotoUrl(data[0].photo_url);
      }
    }

    fetchPhoto();
  }, [businessId]);

  return (
    <div className="relative h-44 sm:h-48 md:h-52 overflow-hidden bg-gradient-to-br from-primary/20 to-primary/5">
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={businessName}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center">
          <Building2 className="w-16 h-16 text-primary/30" />
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-foreground/60 to-transparent" />
    </div>
  );
}
